import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { forbiddenDocValidator,AzimuthRangeValidator, AltitudeRangeValidator } from 'src/app/data-validation/data-validators.service';
import { Sectorization } from 'src/app/models/sectorization';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { NavaidsService } from 'src/app/services/navaids.service';

@Component({
  selector: 'app-add-sectorizations',
  templateUrl: './add-sectorizations.component.html',
  styleUrls: ['./add-sectorizations.component.scss'],
  standalone: false
})
export class AddSectorizationsComponent implements OnInit {

  sect : Sectorization;

  docValid : boolean = true;
  minAzimuthValid : boolean = true;
  maxAzimuthValid : boolean = true;
  minaltitudeValid : boolean = true;
  maxaltitudeValid : boolean = true;

  isBiggerThenAzimuthValid : boolean = false

  isBiggerThenAltitudeValid : boolean = false

  constructor(public navaidService : NavaidsService, private configurationService : ConfigurationService) {
    this.sect = new Sectorization();
  }

  ngOnInit(): void {
    /*this.sectForm = new FormGroup({
      doc: new FormControl(this.sect.doc,[Validators.required,
        forbiddenDocValidator(160,1)]),
      minazimuth : new FormControl(this.sect.minangle,[Validators.required, Validators.min(0), Validators.max(360)]),
      maxazimuth : new FormControl(this.sect.maxangle,[Validators.required, Validators.min(0), Validators.max(360)]),
      minaltitude : new FormControl(this.sect.minaltitude,[Validators.required, Validators.min(0), Validators.max(this.navaidService.selectedNavaid? this.navaidService.selectedNavaid.maxaltitude : 60000)]),
      maxaltitude : new FormControl(this.sect.maxaltitude,[Validators.required, Validators.min(0), Validators.max(this.navaidService.selectedNavaid? this.navaidService.selectedNavaid.maxaltitude : 60000)])
    },
    {validators: [AzimuthRangeValidator, AltitudeRangeValidator]});*/
  }

  cancelSectorization():void{
    this.navaidService.activeSectorizations = !this.navaidService.activeSectorizations;
    this.sect = new Sectorization();
    this.docValid= true;
    this.minAzimuthValid  = true;
    this.maxAzimuthValid  = true;
    this.minaltitudeValid  = true;
    this.maxaltitudeValid  = true;

    this.isBiggerThenAzimuthValid  = false

    this.isBiggerThenAltitudeValid  = false
  }

  addSectorization():void {
    this.navaidService.selectedNavaid.addSectorization(this.sect);
    this.sect = new Sectorization();
    this.navaidService.activeSectorizations = !this.navaidService.activeSectorizations;
  }

  checkFormValid() {
    let docValue : boolean = this.sect.doc != null;
    let minAzimuthValue : boolean = this.sect.minangle != null;
    let maxAzimuthValue : boolean = this.sect.maxangle != null;
    let minAltitudeValue : boolean = this.sect.minaltitude != null;
    let maxAltitudeValue : boolean = this.sect.maxaltitude != null;
    return this.docValid && this.minAzimuthValid && this.maxAzimuthValid && this.minaltitudeValid && this.maxaltitudeValid
    && docValue && minAzimuthValue && maxAzimuthValue && minAltitudeValue && maxAltitudeValue && !this.isBiggerThenAltitudeValid
    && !this.isBiggerThenAzimuthValid;
  }

  azimuthIsBiggerThen(value1 : any, value2: any){
    if(value1 != undefined && value2 != undefined){
      if (value1 > value2){
        this.isBiggerThenAzimuthValid = true;
      }else {
        this.isBiggerThenAzimuthValid = false;
      }
    }else {
      this.isBiggerThenAzimuthValid = false;
    }
  }

  altitudeIsBiggerThen(value1 : any, value2: any){
    if(value1 != undefined && value2 != undefined){
      if (value1 > value2){
        this.isBiggerThenAltitudeValid = true;
      }else {
        this.isBiggerThenAltitudeValid = false;
      }
    }else {
      this.isBiggerThenAltitudeValid = false;
    }
  }

  isValueValid(type : string, value : any) : void {
    if (value != null) {
      switch(type) {
        case "doc":
          if (!(Number.parseFloat(value) >= 1 && Number.parseFloat(value) <= this.configurationService.currentConfiguration.facilityConfiguration.docMaxRange)){
            this.docValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.docValid = true;
          }
          break;
        case "minazimuth":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 360)){
            this.minAzimuthValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.minAzimuthValid = true;
          }
          break;
        case "maxazimuth":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 360)){
            this.maxAzimuthValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.maxAzimuthValid = true;
          }
          break;
        case "minaltitude":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= this.navaidService.selectedNavaid.maxaltitude)){
            this.minaltitudeValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.minaltitudeValid = true;
          }
          break;
        case "maxaltitude":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= this.navaidService.selectedNavaid.maxaltitude)){
            this.maxaltitudeValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.maxaltitudeValid = true;
          }
            break;
      }
    }
  }
}
